// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import './styles/meily_jtl_wawi.css'
// import LoadingIndicator from "../utils/loading/LoadingIndicator";
// import { useLoading } from "../utils/loading/LoadingContext"; // Use global loading context


// const MeilyJtlWawi = () => {
//   const [orders, setOrders] = useState([]);
//   const { loading, setLoading } = useLoading();
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(null);
//   const [totalPages, setTotalPages] = useState(1);
//   const [hasPreviousPage, setHasPreviousPage] = useState(false);
//   const [hasNextPage, setHasNextPage] = useState(false);
//   const [nextPageNumber, setNextPageNumber] = useState(null);
//   const [previousPageNumber, setPreviousPageNumber] = useState(null);

//   const salesChannelsRef = useRef({});
//   const paymentMethodsRef = useRef({});
//   const shippingMethodsRef = useRef({});
//   const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;

//   // Manually define missing sales channels
//   const manualSalesChannels = {
//     '5-31-2': 'Ebay Meily',
//     '5-31-4': 'Ebay Lastpycs',
//     '11-8-7-9': 'Otto',
//     // Add more channels as necessary
//   };

//   const manualPaymentMethods = {
//     null: 'ebay',
//     'paymentMethod2': 'Credit Card Lastpycs',
//     // Add more payment methods as necessary
//   };

//   useEffect(() => {
//     // Fetch mappings and then load the last page of sales orders
//     fetchMappings().then(() => {
//       fetchTotalPages();
//     });
//   }, []);

//   const fetchMappings = async () => {
//     try {
//       const [channelsRes, paymentsRes, shippingRes] = await Promise.all([
//         axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/salesChannels/`, getHeaders()),
//         axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/paymentMethods/`, getHeaders()),
//         axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/shippingMethods/`, getHeaders()),
//       ]);

//       // Combine API and manual data
//       const combinedSalesChannels = { ...mapById(channelsRes.data), ...manualSalesChannels };
//       const combinedPaymentMethods = { ...mapById(paymentsRes.data), ...manualPaymentMethods };

//       salesChannelsRef.current = combinedSalesChannels;
//       paymentMethodsRef.current = combinedPaymentMethods;
//       shippingMethodsRef.current = mapById(shippingRes.data);
//     } catch (err) {
//       console.error('Error fetching mappings', err);
//     }
//   };
//   const refreshOrders = () => {
//     // Re-fetch the current page's data
//     fetchSalesOrders(currentPage);
//   };


//   const fetchTotalPages = async () => {
//     try {
//       const response = await axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/salesorders/`, {
//         ...getHeaders(),
//         params: {
//           pageNumber: 1, // Fetch the first page to get total pages
//         },
//       });
//       const data = response.data;
//       setTotalPages(data.TotalPages);
//       // Fetch the last page after getting the total
//       fetchSalesOrders(data.TotalPages);
//     } catch (error) {
//       console.error('Failed to fetch total pages', error);
//     }
//   };

//   const fetchSalesOrders = async (pageNumber) => {
//     setLoading(true);
//     setError(null);

//     try {
//       const response = await axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/salesorders/`, {
//         ...getHeaders(),
//         params: {
//           pageNumber: pageNumber,
//         },
//       });

//       const data = response.data;

//       // Sort orders by SalesOrderDate in descending order (latest first)
//       const sortedOrders = data.Items.sort((a, b) => {
//         return new Date(b.SalesOrderDate) - new Date(a.SalesOrderDate);
//       });

//       setOrders(sortedOrders);
//       setTotalPages(data.TotalPages);
//       setHasPreviousPage(data.HasPreviousPage);
//       setHasNextPage(data.HasNextPage);
//       setNextPageNumber(data.NextPageNumber);
//       setPreviousPageNumber(data.PreviousPageNumber);
//       setCurrentPage(pageNumber);
//     } catch (error) {
//       console.error('Failed to fetch sales orders', error);
//       setError('Failed to fetch sales orders');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const mapById = (arr) => {
//     return arr.reduce((acc, item) => {
//       acc[item.Id] = item.Name; // Assuming the response has Id and Name
//       return acc;
//     }, {});
//   };

//   const getHeaders = () => ({
//     headers: {
//       Authorization: `Wawi 6701bb2c-407b-41e9-bf20-bf1520c8e6e4`,
//       'X-AppId': 'meily/v1',
//       'X-AppVersion': '1.0.0',
//     },
//   });

//   const handleNextPage = () => {
//     if (hasNextPage) {
//       fetchSalesOrders(nextPageNumber);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (hasPreviousPage) {
//       fetchSalesOrders(previousPageNumber);
//     }
//   };

//   const getSalesChannelName = (salesChannelId) => {
//     return salesChannelsRef.current[salesChannelId] || salesChannelId;
//   };

//   if (loading) return <p>Loading sales orders...</p>;
//   if (error) return <p>{error}</p>;

//   return (
//     <div className='jtl-wawi-body'>
//       <div className="jtl-wawi-header">
//         <h1>Jtl sales orders</h1>
//         <button className="jtl-wawi-refresh" onClick={refreshOrders}>
//           Refresh
//         </button>
//       </div>
//       <table className="jtl-wawi-table">
//         <thead>
//           <tr>
//             <th className="jtl-wawi-th">Created on</th>
//             <th className="jtl-wawi-th">Sales order ID</th>
//             <th className="jtl-wawi-th">Platform</th>
//             <th className="jtl-wawi-th">Sales order value gross</th>
//             <th className="jtl-wawi-th">Currency</th>
//             <th className="jtl-wawi-th">Is Paid</th>
//             <th className="jtl-wawi-th">Payment method</th>
//             <th className="jtl-wawi-th">Shipping method</th>
//             <th className="jtl-wawi-th">Delivery status</th>
//             <th className="jtl-wawi-th">Last name</th>
//             <th className="jtl-wawi-th">First name</th>
//             <th className="jtl-wawi-th">Street</th>
//             <th className="jtl-wawi-th">City</th>
//             <th className="jtl-wawi-th">Postal code</th>
//             <th className="jtl-wawi-th">Country</th>
//           </tr>
//         </thead>
//         <tbody className="jtl-wawi-tbody">
//           {orders.map((order) => {
//             const salesChannelName = getSalesChannelName(order.SalesChannelId);
//             return (
//               <tr key={order.Id} className="jtl-wawi-tr" data-channel={salesChannelName}>
//                 <td className="jtl-wawi-td">
//                   {new Date(order.SalesOrderDate).toLocaleString('en-US', {
//                     year: '2-digit',
//                     month: 'numeric',
//                     day: 'numeric',
//                     hour: 'numeric',
//                     minute: 'numeric',
//                     second: 'numeric',
//                     hour12: true, // 12-hour format with AM/PM
//                   })}
//                 </td>
//                 <td className="jtl-wawi-td">{order.Number}</td>
//                 <td className="jtl-wawi-td">{salesChannelName}</td>
//                 <td className="jtl-wawi-td">{order.SalesOrderPaymentDetails.TotalGrossAmount}</td>
//                 <td className="jtl-wawi-td">{order.SalesOrderPaymentDetails.CurrencyIso}</td>
//                 <td className="jtl-wawi-td">{order.SalesOrderPaymentDetails.PaymentStatus === 2 ? 'Yes' : 'No'}</td>
//                 <td className="jtl-wawi-td">{paymentMethodsRef.current[order.SalesOrderPaymentDetails.PaymentMethodId] || 'ebay'}</td>
//                 <td className="jtl-wawi-td">{shippingMethodsRef.current[order.SalesOrderShippingDetail.ShippingMethodId] || order.SalesOrderShippingDetail.ShippingMethodId}</td>
//                 <td className="jtl-wawi-td">{order.SalesOrderShippingDetail.DeliveryCompleteStatus === 1 ? 'Delivered' : 'Not Delivered'}</td>
//                 <td className="jtl-wawi-td">{order.BillingAddress.LastName}</td>
//                 <td className="jtl-wawi-td">{order.BillingAddress.FirstName}</td>
//                 <td className="jtl-wawi-td">{order.BillingAddress.Street}</td>
//                 <td className="jtl-wawi-td">{order.BillingAddress.City}</td>
//                 <td className="jtl-wawi-td">{order.BillingAddress.PostalCode}</td>
//                 <td className="jtl-wawi-td">{order.BillingAddress.CountryIso}</td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>

//       <div>
//         {/* Pagination controls */}
//         <button className="jtl-wawi-button" onClick={handlePreviousPage} disabled={!hasPreviousPage}>
//           Previous Page
//         </button>
//         <span>
//           Page {currentPage} of {totalPages}
//         </span>
//         <button className="jtl-wawi-button" onClick={handleNextPage} disabled={!hasNextPage}>
//           Next Page
//         </button>
//       </div>
//     </div>
//   );
// };

// export default MeilyJtlWawi;

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './styles/meily_jtl_wawi.css'; // Ensure this is loaded correctly
import LoadingIndicator from "../utils/loading/LoadingIndicator";
import { useLoading } from "../utils/loading/LoadingContext"; // Use global loading context

const MeilyJtlWawi = () => {
  const [orders, setOrders] = useState([]);
  const { loading, setLoading } = useLoading(); // Global loading
  const [localLoading, setLocalLoading] = useState(true); // Local loading state for the component
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [hasPreviousPage, setHasPreviousPage] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [nextPageNumber, setNextPageNumber] = useState(null);
  const [previousPageNumber, setPreviousPageNumber] = useState(null);

  const salesChannelsRef = useRef({});
  const paymentMethodsRef = useRef({});
  const shippingMethodsRef = useRef({});
  const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;

  // Manually define missing sales channels
  const manualSalesChannels = {
    '5-31-2': 'Ebay Meily',
    '5-31-4': 'Ebay Lastpycs',
    '11-8-7-9': 'Otto',
  };

  const manualPaymentMethods = {
    null: 'ebay',
    'paymentMethod2': 'Credit Card Lastpycs',
  };

  useEffect(() => {
    setLocalLoading(true); // Start loading when component mounts

    // Fetch mappings and then load the last page of sales orders
    fetchMappings()
      .then(() => fetchTotalPages())
      .finally(() => setLocalLoading(false)); // Loading is complete once all data is fetched
  }, []);

  const fetchMappings = async () => {
    try {
      const [channelsRes, paymentsRes, shippingRes] = await Promise.all([
        axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/salesChannels/`, getHeaders()),
        axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/paymentMethods/`, getHeaders()),
        axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/shippingMethods/`, getHeaders()),
      ]);

      const combinedSalesChannels = { ...mapById(channelsRes.data), ...manualSalesChannels };
      const combinedPaymentMethods = { ...mapById(paymentsRes.data), ...manualPaymentMethods };

      salesChannelsRef.current = combinedSalesChannels;
      paymentMethodsRef.current = combinedPaymentMethods;
      shippingMethodsRef.current = mapById(shippingRes.data);
    } catch (err) {
      console.error('Error fetching mappings', err);
    }
  };

  const refreshOrders = () => {
    fetchSalesOrders(currentPage);
  };

  const fetchTotalPages = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/salesorders/`, {
        ...getHeaders(),
        params: {
          pageNumber: 1,
        },
      });
      const data = response.data;
      setTotalPages(data.TotalPages);
      fetchSalesOrders(data.TotalPages);
    } catch (error) {
      console.error('Failed to fetch total pages', error);
    }
  };

  const fetchSalesOrders = async (pageNumber) => {
    setLoading(true); // Set global loading
    setError(null);

    try {
      const response = await axios.get(`${baseUrl}/api/proxy/eazybusiness/v1/salesorders/`, {
        ...getHeaders(),
        params: {
          pageNumber: pageNumber,
        },
      });

      const data = response.data;
      const sortedOrders = data.Items.sort((a, b) => new Date(b.SalesOrderDate) - new Date(a.SalesOrderDate));

      setOrders(sortedOrders);
      setTotalPages(data.TotalPages);
      setHasPreviousPage(data.HasPreviousPage);
      setHasNextPage(data.HasNextPage);
      setNextPageNumber(data.NextPageNumber);
      setPreviousPageNumber(data.PreviousPageNumber);
      setCurrentPage(pageNumber);
    } catch (error) {
      console.error('Failed to fetch sales orders', error);
      setError('Failed to fetch sales orders');
    } finally {
      setLoading(false); // Stop global loading
    }
  };

  const mapById = (arr) => {
    return arr.reduce((acc, item) => {
      acc[item.Id] = item.Name;
      return acc;
    }, {});
  };

  const getHeaders = () => ({
    headers: {
      Authorization: `Wawi 6701bb2c-407b-41e9-bf20-bf1520c8e6e4`,
      'X-AppId': 'meily/v1',
      'X-AppVersion': '1.0.0',
    },
  });

  const handleNextPage = () => {
    if (hasNextPage) {
      fetchSalesOrders(nextPageNumber);
    }
  };

  const handlePreviousPage = () => {
    if (hasPreviousPage) {
      fetchSalesOrders(previousPageNumber);
    }
  };

  const getSalesChannelName = (salesChannelId) => {
    return salesChannelsRef.current[salesChannelId] || salesChannelId;
  };

  // Conditional rendering for loading state
  if (localLoading || loading) return <LoadingIndicator />;

  if (error) return <p>{error}</p>;

  return (
    <div className='jtl-wawi-body'>
      <div className="jtl-wawi-header">
        <h1>Jtl sales orders</h1>
        <button className="jtl-wawi-refresh" onClick={refreshOrders}>
          Refresh
        </button>
      </div>
      <table className="jtl-wawi-table">
        <thead>
          <tr>
            <th className="jtl-wawi-th">Created on</th>
            <th className="jtl-wawi-th">Sales order ID</th>
            <th className="jtl-wawi-th">Platform</th>
            <th className="jtl-wawi-th">Sales order value gross</th>
            <th className="jtl-wawi-th">Currency</th>
            <th className="jtl-wawi-th">Is Paid</th>
            <th className="jtl-wawi-th">Payment method</th>
            <th className="jtl-wawi-th">Shipping method</th>
            <th className="jtl-wawi-th">Delivery status</th>
            <th className="jtl-wawi-th">Last name</th>
            <th className="jtl-wawi-th">First name</th>
            <th className="jtl-wawi-th">Street</th>
            <th className="jtl-wawi-th">City</th>
            <th className="jtl-wawi-th">Postal code</th>
            <th className="jtl-wawi-th">Country</th>
          </tr>
        </thead>
        <tbody className="jtl-wawi-tbody">
          {orders.map((order) => {
            const salesChannelName = getSalesChannelName(order.SalesChannelId);
            return (
              <tr key={order.Id} className="jtl-wawi-tr" data-channel={salesChannelName}>
                <td className="jtl-wawi-td">
                  {new Date(order.SalesOrderDate).toLocaleString('en-US', {
                    year: '2-digit',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: true, // 12-hour format with AM/PM
                  })}
                </td>
                <td className="jtl-wawi-td">{order.Number}</td>
                <td className="jtl-wawi-td">{salesChannelName}</td>
                <td className="jtl-wawi-td">{order.SalesOrderPaymentDetails.TotalGrossAmount}</td>
                <td className="jtl-wawi-td">{order.SalesOrderPaymentDetails.CurrencyIso}</td>
                <td className="jtl-wawi-td">{order.SalesOrderPaymentDetails.PaymentStatus === 2 ? 'Yes' : 'No'}</td>
                <td className="jtl-wawi-td">{paymentMethodsRef.current[order.SalesOrderPaymentDetails.PaymentMethodId] || 'ebay'}</td>
                <td className="jtl-wawi-td">{shippingMethodsRef.current[order.SalesOrderShippingDetail.ShippingMethodId] || order.SalesOrderShippingDetail.ShippingMethodId}</td>
                <td className="jtl-wawi-td">{order.SalesOrderShippingDetail.DeliveryCompleteStatus === 1 ? 'Delivered' : 'Not Delivered'}</td>
                <td className="jtl-wawi-td">{order.BillingAddress.LastName}</td>
                <td className="jtl-wawi-td">{order.BillingAddress.FirstName}</td>
                <td className="jtl-wawi-td">{order.BillingAddress.Street}</td>
                <td className="jtl-wawi-td">{order.BillingAddress.City}</td>
                <td className="jtl-wawi-td">{order.BillingAddress.PostalCode}</td>
                <td className="jtl-wawi-td">{order.BillingAddress.CountryIso}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div>
        <button onClick={handlePreviousPage} disabled={!hasPreviousPage}>Previous Page</button>
        <span>Page {currentPage} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={!hasNextPage}>Next Page</button>
      </div>
    </div>
  );
};

export default MeilyJtlWawi;
